import React, { Component, useRef, useEffect, useState } from "react";
import { window } from "global";
import { useGlobal } from "reactn";
import { Link, NavLink, useLocation, UseLocation } from "react-router-dom";
import classnames from "classnames";
import ReactSVG from "react-svg";
import { useSideNav, useMobileToggleSideNav } from "hooks/general-hooks";
import { TooltipContainer } from "@outplayed/tooltips";

import MediaQuery from "components/MediaQuery";
// import NewSideNavLinks from "components/SideNav/NewSideNavLinks";
import SideNavLinks from "components/SideNav/SideNavLinks";
import { useQuery } from "@apollo/client";
import { useLoginState } from "lib/hooks/userHooks";
import { GET_USER_STATE } from "api/graphql/queries";
import { useUserSummonerName } from "lib/hooks/userHooks";
import { getRegionId } from "lib/region_helper";
import { useLightMode } from "hooks/general-hooks";
import { generateTierList, convertToRoleTierList } from "../../lib/FilterPreferences/QueryParams";
import { parseQueryString } from "../../lib/general-helper";
import { useActiveSpecialModes } from "../../lib/hooks/specialModeHooks";
import { ReactComponent as ButtonDown } from "svg/button-down.svg";
import { ReactComponent as ButtonUp } from "svg/button-up2.svg";
import { ReactComponent as LolLogo } from "svg/lol.svg";
import { ReactComponent as LolSelectorLogo } from "svg/League-SelectorLogo.svg";
import { ReactComponent as LolLogoLightMode } from "svg/lol-light-mode.svg";
import { ReactComponent as PentagonHouse } from "svg/pentagon-house.svg";
import { ReactComponent as PaperWriting } from "svg/paper-writing.svg";
import { ReactComponent as Skullhead } from "svg/skull-head.svg";
import { ReactComponent as PaperSearch } from "svg/paper-search.svg";
import { ReactComponent as Camera } from "svg/camera.svg";
import { ReactComponent as Trophy } from "svg/trophy.svg";
import { ReactComponent as Sword } from "svg/sword.svg";
import { ReactComponent as ProBuildStatsLogo } from "svg/probuildstats-logo.svg";
import { ReactComponent as OnlyGuidesLogo } from "svg/onlyguides-logo.svg";
import { ReactComponent as ValorantLogo } from "svg/valorant-logo.svg";
import { ReactComponent as TeamTLogo } from "svg/teamt-logo.svg";
import { ReactComponent as WowLogo } from "svg/WoW-SelectorLogo.svg";

const NewSideNavLinks = (props) => {
  const [expandedSideNav] = useSideNav();
  const toggleSideNav = useMobileToggleSideNav();
  const [loadingIcon, setLoadingIcon] = useState(true);
  const location = useLocation();

  const {
    className,
    url,
    description,
    newTag,
    href,
    icon,
    dropdownInfo,
    collapsed,
    horizontal,
    dropdownClassName,
    dropdownForceOpen,
    isExternal,
  } = props;

  const descriptionStyle = props.descriptionStyle ? props.descriptionStyle : "";

  let isActive = false;
  let forceOpen = false;

  if (!dropdownInfo) {
    isActive = location.pathname === url.pathname;
  } else {
    //The last two cases are for when we remove some of the query for the default parameters
    isActive = dropdownInfo.some((item) => {
      return (
        item[1] === location.pathname ||
        item[1] === location.search ||
        item[1] === location.pathname + location.search ||
        (item[1].slice(0, -1) === location.pathname.slice(-14) || item[1].slice(-9)) === location.pathname.slice(-9)
      );
    });
    forceOpen = isActive || dropdownForceOpen;
  }

  const sideLinkClassNames = classnames(["side-link", "side-nav-title", className]);

  const Dropdown = (props) => {
    const { classTitle, dropdownInfo, collapsed, forceOpen, isExternal } = props;
    const [dropdownItems, setDropdownItems] = useState(forceOpen);
    const [forceOpen1, setForceOpen] = useState(forceOpen);

    const handleDropdownItems = () => {
      setDropdownItems(!dropdownItems);
      if (forceOpen1) {
        setForceOpen(false);
      }
    };

    if (dropdownInfo) {
      if (!horizontal) {
        return (
          <>
            {collapsed === "expanded" && (
              <div className="smaller-section">
                {dropdownItems ? (
                  <div className="game-dropdown-button" onClick={handleDropdownItems}>
                    <ButtonDown onClick={handleDropdownItems} style={{ rotate: "180deg" }} />
                  </div>
                ) : (
                  <div className="game-dropdown-button" onClick={handleDropdownItems}>
                    <ButtonDown onClick={handleDropdownItems} style={{ rotate: forceOpen1 ? "180deg" : "" }} />
                  </div>
                )}
              </div>
            )}
            {(dropdownItems || forceOpen1) &&
              collapsed === "expanded" &&
              dropdownInfo.map((single_dropdown, index) => {
                const linkType = isExternal ? <a /> : <NavLink />;
                return (
                  <div key={index} className="dropdown-container">
                    {React.cloneElement(
                      linkType,
                      {
                        className: dropdownClassName,
                        href: isExternal ? `https://u.gg${single_dropdown[1]}` : single_dropdown[1],
                        to: single_dropdown[1],
                        activeClassName: "dropdown-active",
                      },
                      <div className="dropdown-item-2">
                        <span className={dropdownClassName}>{single_dropdown[0]}</span>
                      </div>,
                    )}
                  </div>
                );
              })}
          </>
        );
      } else {
        return (
          <>
            {collapsed === "expanded" && (
              <div className="smaller-section">
                {dropdownItems ? (
                  <div className="game-dropdown-button" onClick={handleDropdownItems}>
                    <ButtonDown onClick={handleDropdownItems} style={{ rotate: "180deg" }} />
                  </div>
                ) : (
                  <div className="game-dropdown-button" onClick={handleDropdownItems}>
                    <ButtonDown onClick={handleDropdownItems} style={{ rotate: forceOpen1 ? "180deg" : "" }} />
                  </div>
                )}
              </div>
            )}
            <div className="all-dropdowns-holder">
              {(dropdownItems || forceOpen1) &&
                collapsed === "expanded" &&
                dropdownInfo.map((single_dropdown, index) => {
                  const linkType = isExternal ? <a /> : <Link />;
                  return (
                    <div key={index} className="dropdown-container-horz">
                      {React.cloneElement(
                        linkType,
                        {
                          className: classTitle + "-horz",
                          href: isExternal ? `https://u.gg${single_dropdown[1]}` : single_dropdown[1],
                          to: single_dropdown[1],
                        },
                        <div className="dropdown-item-horz">
                          <span className={classTitle + "-horz"}>{single_dropdown[0]}</span>
                        </div>,
                      )}
                    </div>
                  );
                })}
            </div>
          </>
        );
      }
    }

    return null;
  };

  return (
    <>
      <LinkComponent
        href={href}
        url={url}
        sideLinkClassNames={sideLinkClassNames}
        dropdownClassName={dropdownClassName}
        description={description}
        dropdownInfo={dropdownInfo}
      >
        <div
          className={isActive ? "active-icon" : "not-active-icon"}
          style={{
            height: expandedSideNav ? "31px" : "40px",
            minWidth: "40px",
            borderRadius: "3px",
            marginBottom: expandedSideNav ? "9px" : "0px",
          }}
        >
          <div className="side-icons" style={{ height: "20px", width: "20px" }}>
            {icon}
          </div>
        </div>
        <span className={isActive ? descriptionStyle + "-active" : descriptionStyle}>{description}</span>
      </LinkComponent>

      {dropdownInfo && (
        <Dropdown
          descriptionStyle="dropdown-text"
          classTitle="dropdown-text"
          dropdownInfo={dropdownInfo}
          collapsed={collapsed}
          horizontal={horizontal}
          dropdownClassName={dropdownClassName}
          forceOpen={forceOpen}
          isExternal={isExternal}
        ></Dropdown>
      )}
    </>
  );
};

const LinkComponent = (props) => {
  const toggleSideNav = useMobileToggleSideNav();
  const { href, url, sideLinkClassNames, dropdownInfo } = props;

  let isActive = false;

  if (!dropdownInfo) {
    isActive = location.pathname === url.pathname;
  } else {
    isActive = dropdownInfo.some((item) => {
      return (
        item[1] === location.pathname ||
        item[1] === location.search ||
        item[1] === location.pathname + location.search ||
        (item[1].slice(0, -1) === location.pathname.slice(-14) || item[1].slice(-9)) === location.pathname.slice(-9)
      );
    });
  }
  const isActiveFn = function (a, b) {
    return isActive;
  };

  return href ? (
    <a className={sideLinkClassNames} href={url.pathname} target="_blank" rel="noreferrer">
      {props.children}
    </a>
  ) : (
    <NavLink
      className={sideLinkClassNames}
      activeClassName="active"
      to={url.pathname}
      onClick={toggleSideNav}
      isActive={isActiveFn}
    >
      {props.children}
    </NavLink>
  );
};

const NewLeagueLinks = (props) => {
  const [loggingIn] = useGlobal("loggingIn");
  const [expandedSideNav] = useGlobal("expandedSideNav");
  const isLoggedIn = useLoginState();
  const { data: userState } = useQuery(GET_USER_STATE);
  const { filterDefaults, premium } = (userState && userState.getState) || {};
  const userData = useUserSummonerName();
  const { lightModeOn } = useLightMode();
  const filterParams = generateTierList(filterDefaults);
  const tierListLocation = convertToRoleTierList(parseQueryString(filterParams.substring(1)));
  const liveSpecialModes = useActiveSpecialModes();

  let lolLogo = lightModeOn ? <LolLogoLightMode /> : <LolLogo />;
  const { collapsed } = props;

  let profile_overview = "/login";
  let profile_champion = "/login";
  let profile_live_game = "/login";
  let tierListPathname = "/lol/tier-list";

  if (isLoggedIn) {
    let region = userData.regionId;
    let summonerName = userData.summonerName;

    if (summonerName) {
      summonerName = summonerName.toLowerCase();
    }
    profile_overview = "/lol/profile/" + region + "/" + summonerName + "/overview";
    profile_champion = "/lol/profile/" + region + "/" + summonerName + "/champion-stats";
    profile_live_game = "/lol/profile/" + region + "/" + summonerName + "/live-game";
    if (tierListLocation) {
      tierListPathname = `${tierListLocation.pathname}?${tierListLocation.search}`;
    }
  }

  const specialModesInfo = {
    urf: ["URF Tier List", "/lol/urf-tier-list"],
    normal_aram: ["ARAM Tier List", "/lol/aram-tier-list"],
    arurf: ["ARURF Tier List", "/lol/arurf-tier-list"],
    nexus_blitz: ["Nexus Blitz Tier List", "/lol/nexus-blitz-tier-list"],
    one_for_all: ["One For All Tier List", "/lol/one-for-all-tier-list"],
  };

  const tierListDropdownInfo = [
    ["Tier List", tierListPathname, "tier-list"],
    ["Duo Tier List", "/lol/duo-tier-list", "duo"],
    ["Combat", "/lol/combat", "combat"],
    ["Objectives", "/lol/objectives", "objectives"],
  ];

  // Adding special game modes to the tier list dropdown
  for (let i = 0; i < liveSpecialModes.length; i++) {
    let element = specialModesInfo[liveSpecialModes[i]];
    tierListDropdownInfo.splice(1, 0, element);
  }

  if (!window) return null;
  return (
    <React.Fragment>
      {/* Start by writing out the game switcher */}
      {/* The div has the class name as new-game-navigator */}
      <MediaQuery min="MOBILE_SMALL" max="DESKTOP_LARGE" renderNullOnFail isClient>
        <div className="new-game-navigator">
          <div className="add-dropdown-button">
            <NewSideNavLinks
              url={{ pathname: "/", search: "" }}
              description={"League Of Legends"}
              icon={lolLogo}
              descriptionStyle="game-changer"
              className="grad-background"
              dropdownClassName={"dropdown-container"}
              collapsed={collapsed}
              horizontal={true}
              dropdownInfo={[
                [
                  <div className="game-selector-container active">
                    <LolSelectorLogo />
                  </div>,
                  "/",
                ],
                [
                  <div className="game-selector-container">
                    <WowLogo />
                  </div>,
                  "/wow/",
                ],
              ]}
              dropdownForceOpen
              isExternal
            />
          </div>
          {isLoggedIn ? (
            <div className="add-dropdown-button">
              <NewSideNavLinks
                url={{ pathname: profile_overview }}
                description={"Home"}
                icon={<PentagonHouse style={{ fill: "white" }} />}
                descriptionStyle="emphasised-side-nav"
                className="add-hover"
                dropdownClassName={"standard-dropdown"}
                collapsed={collapsed}
                dropdownInfo={[
                  ["Overview", profile_overview],
                  ["Champion Stats", profile_champion],
                  ["Live Game", profile_live_game],
                ]}
              />
            </div>
          ) : null}
          <NewSideNavLinks
            url={{ pathname: tierListPathname }}
            description={"Tier List"}
            icon={<PaperWriting />}
            descriptionStyle="emphasised-side-nav"
            className="add-hover"
            dropdownClassName={"standard-dropdown"}
            collapsed={collapsed}
            dropdownInfo={tierListDropdownInfo}
          />
          <NewSideNavLinks
            url={{ pathname: "/lol/champions" }}
            description={"Champions"}
            icon={<Skullhead />}
            descriptionStyle="emphasised-side-nav"
            className="add-hover"
          />
          <NewSideNavLinks
            url={{ pathname: "/multisearch", search: "utm_source=uggapp" }}
            description={"Multisearch"}
            icon={<PaperSearch />}
            descriptionStyle="emphasised-side-nav"
            className="add-hover"
            collapsed={collapsed}
          />
          <NewSideNavLinks
            url={{ pathname: "/lg-splash", search: "utm_source=uggapp" }}
            description={"Live Games"}
            icon={<Camera />}
            descriptionStyle="emphasised-side-nav"
            className="add-hover"
          />
          <NewSideNavLinks
            url={{
              pathname: "/leaderboards/ranking",
              search: "utm_source=uggapp",
            }}
            description={"Leaderboards"}
            icon={<Trophy />}
            descriptionStyle="emphasised-side-nav"
            className="add-hover"
          />
          <NewSideNavLinks
            url={{ pathname: "/lol/items", search: "utm_source=uggapp" }}
            description={"Items"}
            icon={<Sword />}
            descriptionStyle="emphasised-side-nav"
            className="add-hover"
            dropdownClassName={"add-hover"}
            collapsed={collapsed}
          />
          <NewSideNavLinks
            url={{ pathname: "https://probuildstats.com" }}
            href={true}
            description={"Probuild Stats"}
            icon={<ProBuildStatsLogo />}
            descriptionStyle="emphasised-side-nav"
            className="add-hover"
          />
          <NewSideNavLinks
            url={{ pathname: "https://onlyguides.com" }}
            href={true}
            description={"OnlyGuides"}
            icon={<OnlyGuidesLogo />}
            descriptionStyle="emphasised-side-nav"
            className="add-hover"
          />
        </div>
      </MediaQuery>
    </React.Fragment>
  );
};

export default NewLeagueLinks;

//I removed this fromthe return for line 215 as in the return for newsidenavelinks
{
  /* {href ? (
        <a className={sideLinkClassNames} href={url.pathname} target="_blank" rel="noreferrer">      <TooltipContainer
          tooltipInfo={description}
          forceOrientation="right"
          disableTooltip={expandedSideNav}
          isFixed
        >
          <div className={isActive ? "active-icon" : "not-active-icon"} style={{ height: expandedSideNav ? "31px" : "40px", minWidth: "40px", borderRadius: "3px", marginBottom: expandedSideNav ? "9px" : "0px" }}>
            <div className="side-icons" style={{ height: "20px", width: "20px", transition: "padding 1.5s" }} >{icon}</div>
          </div>
        </TooltipContainer>
        <span className={isActive ? descriptionStyle + "-active" : descriptionStyle} >{description}</span></a>
      ) : (
        <NavLink
          className={sideLinkClassNames}
          activeClassName="active"
          to={url.pathname}
          onClick={toggleSideNav}
          isActive={isActiveFn}
        >
          <TooltipContainer
            tooltipInfo={description}
            forceOrientation="right"
            disableTooltip={expandedSideNav}
            isFixed
          >
            <div className={isActive ? "active-icon" : "not-active-icon"} style={{ height: expandedSideNav ? "31px" : "40px", minWidth: "40px", borderRadius: "3px", marginBottom: expandedSideNav ? "9px" : "0px" }}>
              <div className="side-icons" style={{ height: "20px", width: "20px", transition: "padding 1.5s" }} >{icon}</div>
            </div>
          </TooltipContainer>
          <span className={isActive ? descriptionStyle + "-active" : descriptionStyle} >{description}</span>
        </NavLink>
      )} */
}

//Uncomment this when we start to finish the game changer, expand the side nav when game clicked, goes in the return for newsidenavlinks
// We couldn't finish it since we didn't know how we would be getting to the other game websites
// i.e. domain, url path etc...
// {!horizontal ?
//   <LinkComponent>
//     <TooltipContainer
//       tooltipInfo={description}
//       forceOrientation="right"
//       disableTooltip={expandedSideNav}
//       isFixed
//     >
//       <div className={isActive ? "active-icon" : "not-active-icon"} style={{ height: expandedSideNav ? "31px" : "40px", minWidth: "40px",  borderRadius: "3px", marginBottom: expandedSideNav ? "9px" : "0px" }}>
//         <div className="side-icons">{icon}</div>
//       </div>
//     </TooltipContainer>
//     <span className={isActive ? descriptionStyle + "-active" : descriptionStyle}>{description}</span>
//   </LinkComponent>
//   :
//   <div onClick={toggleSideNav}> fghj
//   <TooltipContainer
//         tooltipInfo={description}
//         forceOrientation="right"
//         disableTooltip={expandedSideNav}
//         isFixed
//       >
//         <div className={isActive ? "active-icon" : "not-active-icon"} style={{ height: expandedSideNav ? "31px" : "40px", minWidth: "40px", borderRadius: "3px", marginBottom: expandedSideNav ? "9px" : "0px" }}>
//           <div className="side-icons">{icon}</div>
//         </div>
//       </TooltipContainer>
//       <span className={isActive ? descriptionStyle + "-active" : descriptionStyle}>{description}</span>
//   </div>
//   }

// {    dropdownNumber &&
//     <Dropdown
//     descriptionStyle="dropdown-text"
//     classTitle="dropdown-text"
//     dropdownInfo={dropdownInfo}
//     collapsed={collapsed}
//     horizontal={horizontal}>
//   </Dropdown>}

//   </>
